export default function moneyToDecimal(value) {
  if (!value) return null;

  value = value.replace(/[^\d,.]/g, "");
  value = value.replace(/\./g, "");
  value = value.replace(",", ".");

  const number = parseFloat(value);

  if (isNaN(number)) return null;

  return parseFloat(number.toFixed(2));
}
